import * as React from 'react';
import { cn } from '@/lib/utils';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        'text-xs font-semibold uppercase tracking-wider text-content-secondary',
        className,
      )}
      {...props}
    >
      {children}
      {required && <span className="ml-0.5 text-status-stuck">*</span>}
    </label>
  ),
);
Label.displayName = 'Label';

export { Label };
